export default "__VITE_PUBLIC_ASSET__1b340b5f__"